import React from "react";

const UpdateOrderDetails = () => {
  return <div>hello</div>;
};

export default UpdateOrderDetails;
